<template>
    <v-card>
        <v-card-title>
        <span class="headline">Restore password</span>
        </v-card-title>
        <v-card-text>
            <v-container grid-list-md>
                <v-layout wrap>
                    <v-flex xs12>
                        <v-text-field v-model="email" label="Email*" required></v-text-field>
                    </v-flex>
                </v-layout>
            </v-container>
            <small>*indicates required field</small>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" @click="$store.commit('OPEN_POPUP', 'Login')" text>Back</v-btn>
            <v-btn color="blue darken-1" @click="restore" text>Submit</v-btn>
        </v-card-actions>      
    </v-card>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: 'Restore',
        data: function () {
            return {
                email: '',
                alert: false,
                alertValue: ""                  
            }
        },
        methods:{
            ...mapActions([
                'restorePassword'
            ]),            
            clear(){
                this.email = ''
            },
            restore(){
                this.restorePassword({email: this.email}).then(
                    res => {
                        res && (this.$store.commit('OPEN_POPUP', 'Login'))
                    }
                ).catch(err => {
                    this.alert = true
                    this.alertValue = err
                })
                
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>